const imagesByCategories = {
    "Ancient Battles": [
        "ancient-battle.gif",
        "Death.gif",
        "Phoenician-battle.gif",
    ],
    "Modern Battles": [
        "battle-napoleonic 1.gif",
        "battle-napoleonic 2.gif"
    ],
    "Naval Battles": [
        "battle-naval-ancient.gif",
        "naval-battle-with-sailing-ships.gif"
    ],
    "Aerial Battles": [
        "battle-airplane.gif",
        "fighter jet.png"
    ],
    "Military Equipment": [
        "battle-tanks 1.gif",
        "tank.png"
    ],
    "Team Sports": [
        "basketball 1.png",
        "football.png"
    ],
    "Individual Sports": [
        "tennis 1.png",
        "golf.png"
    ],
    "Military Sports": [
        "soccer 1.png"
    ],
    "Visual Arts": [
        "art 1.png",
        "ballet.png"
    ],
    "Music": [
        "music 1.png",
        "music 2.png"
    ],
    "Performance": [
        "theater.png"
    ],
    "Military Leaders": [
        "gandhi.gif",
        "napoleon.gif"
    ],
    "Politicians": [
        "churchill.gif",
        "jfk.gif"
    ],
    "Creatives": [
        "roosevelt.gif"
    ],
    "Natural Disasters": [
        "earthquake.gif",
        "explosion.png"
    ],
    "Animals": [],
    "Scientific Technologies": [],
    "Ancient Structures": [
        "colosseum.png",
        "taj mahal.png"
    ],
    "Modern Structures": [],
    "Religious Buildings": [
        "mosque 1.jpg"
    ],
    "Transportation": [
        "airplane-new.gif",
        "motorcycle 1.png"
    ],
    "Computers and Electronics": [
        "computer.png"
    ],
    "Military Technology": [
        "rocket.png"
    ],
    "Religious Symbols": [
        "cross 1.png"
    ],
    "Mythological Figures": [],
    "Business": [
        "business.gif"
    ],
    "Finance": [
        "dollar.png"
    ],
    "Legal Agreements": [
        "agreement 1.gif"
    ]
};

export default imagesByCategories;
